/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelHierarchyLevel.ts                *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/general/hierarchy-level";

export class AutogenModelHierarchyLevel<RowType extends ModelRow> extends Endpoint<RowType, RowHierarchyLevelFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowHierarchyLevel extends ModelRow<RowHierarchyLevelFields> {
	constructor(values?: Partial<RowHierarchyLevelFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowHierarchyLevelFields {
	company_id: string;
	description: string;
	id: string;
	level_number: number;
}

